/**
 * Lo que traen las tarjetas de programa: `front/courses` da el flag en la raíz y `front/programs`
 * dentro de `program` (LUC-454). Las versiones personalizadas son cursos con un `program` rehecho sin
 * flag (`parsePersonalizedPrograms`), así que el de la raíz manda cuando viene.
 */
export type AiProgramTagSource = {
  has_tangerine_ai?: number;
  program?: { has_tangerine_ai?: number } | null;
};

/** Si el programa de la tarjeta tiene la IA activa. Sin flag (backend que aún no lo envía), no. */
export function hasTangerineAi(source: AiProgramTagSource | null | undefined): boolean {
  return (source?.has_tangerine_ai ?? source?.program?.has_tangerine_ai) === 1;
}
